export default __webpack_public_path__ + "static/media/zitro-digital.b1156b49.png";